import { moduleProviderFactory } from 'core/providers';
import { UserList, UserEdit } from 'modules/user/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.user',
				pattern: '/users',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.user.list',
						pattern: '',
						component: UserList,
						authorization: ['coreUserSection.full'],
					},
					{
						name: 'master.app.main.user.edit',
						pattern: '',
						component: UserEdit,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/user/config.js